// extracted by mini-css-extract-plugin
export default {"mainContent":"MainPage_mainContent__3HkvK","mainContentWrapper":"MainPage_mainContentWrapper__QQPKi"};